export const commentEntityTypes = {
  ReportsBalancesPage: 'reports-balances-page',
  ReportsBalancesItem: 'reports-balances-item',
  ReportsHoursAndPayments: 'reports-hours-and-payments',
  UserListComment: 'user-list-comment',
  TableUserItem: 'table-user-item',
  WorkScheduleItem: 'work-schedule-item',
  UserListAvatar: 'user-list-avatar',
  UserListRole: 'user-list-role',
  UserListSkill: 'user-list-skill',
  UserListUserItem: 'user-list-user-item',
  UserCompensations: 'user-compensations',
  SalesChannelItem: 'sales-channel-item',
  SalesReportProject: 'sales-report-project'
}

export default {
  commentEntityTypes
}
